import { mergeObjectEntities } from "src/shared/initializers/typePolicies/helpers/mergeObjectEntities"

export const firmClient = {
  FirmClient: {
    // Period-sensitive counts must stay scoped to their list response rather than the entity id.
    keyFields: false as const,
  },
  FirmClientOrganization: {
    // Counts and matching children belong to this query's period and filters.
    keyFields: false as const,
  },
  FirmClientOrganizationList: {
    fields: {
      entities: { merge: mergeObjectEntities },
    },
  },
  FirmClientList: {
    fields: {
      entities: {
        merge: mergeObjectEntities,
      },
    },
  },
}
